import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Vantaihanghoacontainer from "components/Vantaihanghoa/Vantaihanghoacontainer.js";
export default function BCVantaitt() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo tháng vận tải hàng hóa bằng Container",
            tabContent: <Vantaihanghoacontainer />,
          },
        ]}
      />
    </div>
  );
}
